import { React, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import {
  createIssue,
  reportIssueReset,
} from "../../../features/reportIssue/reportIssueSlice";
import { setViewReportIssueModal } from "features/settings/settingSlice";
import { ModalContainerMain } from "components/modal/modal.styled";
import ModalCloseButton from "components/buttons/ModalCloseButton";
import SpinnerSmall from "components/SpinnerSmall";
import { TbMessageReport } from "react-icons/tb";
import { useTranslation } from "react-i18next";

function ReportIssueModal() {
  const { t } = useTranslation("feedback");
  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const { isIssueSuccess, isIssueLoading } = useSelector(
    (state) => state.issues,
  );

  const handleChange = (e) => {
    if (text.length > 150) {
      return toast.error(t("notAllowed"));
    }
    setText(e.target.value.replace(/[\|&;\$%@"<>\(\)\+#{}]/g, ""));
  };

  const handleSubmit = () => {
    if (text.length > 11) {
      dispatch(
        createIssue({
          issueMessage: text,
        }),
      );
    }
  };

  useEffect(() => {
    if (isIssueSuccess) {
      toast(t("reportSubmitted"));
      dispatch(reportIssueReset());
      dispatch(setViewReportIssueModal(false));
    }
  }, [isIssueSuccess, dispatch]);

  return (
    <ModalContainerMain>
      <IssueModalWrap>
        <ModalCloseButton
          handler={() => dispatch(setViewReportIssueModal(false))}
          size="35px"
          top="10px"
          right="10px"
        />

        <ModalHeading>
          <TbMessageReport
            size={25}
            style={{ marginRight: "10px", color: "var(--lightThemeFontColor)" }}
          />
          <span>{t("reportIssue")}</span>
        </ModalHeading>
        <IssueModalForm>
          <textarea
            value={text}
            onChange={handleChange}
            rows="5"
            cols="30"
            maxLength="150"
            placeholder={t("tellUs")}
          />
          <IssueSubmit disabled={isIssueLoading} onClick={handleSubmit}>
            {isIssueLoading ? <SpinnerSmall /> : t("form.submit")}
          </IssueSubmit>
        </IssueModalForm>
      </IssueModalWrap>
    </ModalContainerMain>
  );
}

export default ReportIssueModal;

const IssueModalWrap = styled.div`
  z-index: 0;
  width: 500px;
  height: fit-content;
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 15px;
  position: relative;
  animation: animate 0.3s;
  padding: 30px;
`;

const ModalHeading = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  margin-top: 10px;
  color: var(--lightThemeFontColor);
  font-family: "Roboto", sans-serif;
`;
const IssueModalForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  margin-top: 10px;
  font-family: "Roboto", sans-serif;
  width: 100%;

  textarea {
    resize: none;
    width: 100%;
    height: 200px;
    padding: 20px;
    border: 1px solid #c7c7c7;
    border-radius: 15px;
    font-family: "Roboto", sans-serif;
    font-size: 17px;
  }
  textarea:focus {
    outline: none;
  }
  textarea::placeholder {
    font-family: "Roboto", sans-serif;
    font-size: 17px;
  }
`;

const IssueSubmit = styled.button`
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  border: none;
  background-color: var(--themeColor);
  margin-top: 15px;
  padding: 15px;
  color: white;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  transition: all 0.3s ease-in-out;
  border-radius: 25px;

  &:hover {
    cursor: pointer;
    background-color: #005bb5c0;
  }
`;
